import React, { useState } from 'react';
import './BuyAsics.css';

const BuyAsics = () => {
  const [quantity, setQuantity] = useState(1);
  const [showHardwareDetails, setShowHardwareDetails] = useState(true);
  const [promocode, setPromocode] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('BTC');
  const [showOtherCrypto, setShowOtherCrypto] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  // Product details
  const product = {
    name: 'Antminer S21 Pro 234TH/s',
    image: 'https://files.ecos.am/asics/png/S21ProGrey.png',
    setup: 'Setup 14 days',
    price: 3300,
    installationFee: 650,
    monthlyHosting: 200,
    specs: {
      power: '3510 W',
      miningPower: '234 TH/s',
      algorithm: 'SHA 256',
      efficiency: '15 W/TH'
    },
    profitability: {
      monthlyOutput: '$312',
      breakeven: '406 days',
      return: '361%'
    }
  };

  const handleQuantityChange = (delta) => {
    const newQuantity = Math.max(1, quantity + delta);
    setQuantity(newQuantity);
  };

  const handleBack = () => {
    window.history.back();
  };

  const calculateDiscount = () => {
    if (quantity >= 10) return 15;
    if (quantity >= 5) return 10;
    return 0;
  };

  const calculateTotal = () => {
    const subtotal = (product.price + product.installationFee) * quantity + product.monthlyHosting;
    const discount = calculateDiscount();
    const discountAmount = (subtotal * discount) / 100;
    return {
      subtotal,
      discount: discountAmount,
      discountPercent: discount,
      total: subtotal - discountAmount
    };
  };

  const totals = calculateTotal();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  };

  return (
    <div className="buy-asics-container">
      <button className="ui-back order-container__back" onClick={handleBack}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15.8333 9.99996H4.16663M4.16663 9.99996L9.99996 15.8333M4.16663 9.99996L9.99996 4.16663" stroke="#475467" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
        <p className="ui-back__button">Back</p>
      </button>

      <div className="order-container__content">
        {/* Left Side - Product Details */}
        <div className="order-container__details">
          <div className="wrapper-hardware">
            <div className="wrapper-hardware__info">
              <div className="wrapper-hardware__info-details">
                <p className="wrapper-hardware__title">{product.name}</p>
                
                <div className="wrapper-hardware__image-block">
                  <div className="wrapper-hardware__asic-image">
                    <img className="wrapper-hardware__img-asic" src={product.image} alt="asic" />
                  </div>
                  <div className="wrapper-hardware__duration-block">
                    <p className="wrapper-hardware__duration">{product.setup}</p>
                  </div>
                </div>

                {/* Quantity Selector */}
                <div className="wrapper-hardware__info-details__quantity">
                  <p className="wrapper-hardware__info-details__quantity-title">Quantity</p>
                  <div className="wrapper-hardware__info-details__quantity-button-block">
                    <button 
                      className="wrapper-hardware__info-details__quantity-button"
                      onClick={() => handleQuantityChange(-1)}
                      disabled={quantity <= 1}
                    >
                      -
                    </button>
                    <p className="wrapper-hardware__info-details__quantity-value">{quantity}</p>
                    <button 
                      className="wrapper-hardware__info-details__quantity-button"
                      onClick={() => handleQuantityChange(1)}
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Hardware Details */}
                <div className="wrapper-hardware__asic-hardware-info">
                  <div className="wrapper-hardware__hardware">
                    <div className="wrapper-hardware__title-block">
                      <h2>Hardware Details</h2>
                      <svg 
                        width="20" 
                        height="20" 
                        viewBox="0 0 20 20" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg" 
                        className="wrapper-hardware__chevron"
                        style={{ transform: showHardwareDetails ? 'rotate(180deg)' : 'rotate(0deg)' }}
                        onClick={() => setShowHardwareDetails(!showHardwareDetails)}
                      >
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="#1570EF" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    
                    {showHardwareDetails && (
                      <div className="wrapper-hardware__info-block">
                        <div className="wrapper-hardware__line line">
                          <div className="text_group textborder">
                            <p className="text_title">Power</p>
                            <p className="text_value">{product.specs.power}</p>
                          </div>
                          <div className="text_group">
                            <p className="text_title">Mining Power</p>
                            <p className="text_value">{product.specs.miningPower}</p>
                          </div>
                        </div>
                        <div className="wrapper-hardware__line line">
                          <div className="text_group textborder">
                            <p className="text_title">Algorithm</p>
                            <p className="text_value">{product.specs.algorithm}</p>
                          </div>
                          <div className="text_group">
                            <p className="text_title">Efficiency</p>
                            <p className="text_value">{product.specs.efficiency}</p>
                          </div>
                        </div>

                        {/* Hosting Info */}
                        <div className="wrapper-hardware__including">
                          <h2>Hosting at ECOS Data Center</h2>
                          <div className="wrapper-hardware__group-icon-block">
                            <div className="wrapper-hardware__group-icon-text icon-border">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10.5337 10.5341V4.32745C10.5337 3.61805 10.5337 3.26335 10.3956 2.99239C10.2742 2.75405 10.0804 2.56028 9.84205 2.43884C9.57109 2.30078 9.21639 2.30078 8.50699 2.30078H3.69366C2.98426 2.30078 2.62956 2.30078 2.3586 2.43884C2.12027 2.56028 1.92649 2.75405 1.80505 2.99239C1.66699 3.26335 1.66699 3.61805 1.66699 4.32745V8.50745C1.66699 9.21685 1.66699 9.57155 1.80505 9.8425C1.92649 10.0808 2.12027 10.2746 2.3586 10.3961C2.62956 10.5341 2.98426 10.5341 3.69366 10.5341H10.5337ZM10.5337 10.5341H13.3203C13.675 10.5341 13.8524 10.5341 13.9879 10.4651C14.107 10.4044 14.2039 10.3075 14.2646 10.1883C14.3337 10.0528 14.3337 9.87548 14.3337 9.52078V7.78718C14.3337 7.63228 14.3337 7.55482 14.3162 7.48193C14.3006 7.41731 14.2751 7.35553 14.2403 7.29887C14.2012 7.23495 14.1464 7.18019 14.0369 7.07065L12.7305 5.76425C12.6209 5.65471 12.5662 5.59994 12.5022 5.56078C12.4456 5.52605 12.3838 5.50046 12.3192 5.48495C12.2463 5.46745 12.1688 5.46745 12.0139 5.46745H10.5337M6.10033 12.1174C6.10033 12.9919 5.39144 13.7008 4.51699 13.7008C3.64254 13.7008 2.93366 12.9919 2.93366 12.1174C2.93366 11.243 3.64254 10.5341 4.51699 10.5341C5.39144 10.5341 6.10033 11.243 6.10033 12.1174ZM13.067 12.1174C13.067 12.9919 12.3581 13.7008 11.4837 13.7008C10.6092 13.7008 9.90033 12.9919 9.90033 12.1174C9.90033 11.243 10.6092 10.5341 11.4837 10.5341C12.3581 10.5341 13.067 11.243 13.067 12.1174Z" stroke="#475467" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                              <p className="wrapper-hardware__text">Shipping and TAX</p>
                            </div>
                            <div className="wrapper-hardware__group-icon-text icon-border">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M3.52051 3.51329C3.52051 2.89174 3.52051 2.58097 3.6501 2.40966C3.763 2.26042 3.93556 2.16807 4.12236 2.15691C4.33679 2.14411 4.59536 2.3165 5.11252 2.66127L11.8425 7.14791C12.2698 7.43279 12.4835 7.57523 12.5579 7.75476C12.623 7.91172 12.623 8.08813 12.5579 8.24509C12.4835 8.42463 12.2698 8.56707 11.8425 8.85195L5.11252 13.3386C4.59536 13.6834 4.33679 13.8557 4.12236 13.8429C3.93556 13.8318 3.763 13.7394 3.6501 13.5902C3.52051 13.4189 3.52051 13.1081 3.52051 12.4866V3.51329Z" stroke="#475467" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                              <p className="wrapper-hardware__text">Set up and launch</p>
                            </div>
                            <div className="wrapper-hardware__group-icon-text">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M4.20033 4.20033L7.05033 7.05033M4.20033 4.20033H2.30033L1.66699 2.30033L2.30033 1.66699L4.20033 2.30033V4.20033ZM12.5977 2.1363L10.9335 3.80046C10.6827 4.05127 10.5573 4.17667 10.5103 4.32128C10.469 4.44848 10.469 4.5855 10.5103 4.7127C10.5573 4.85731 10.6827 4.98272 10.9335 5.23353L11.0838 5.38379C11.3346 5.6346 11.46 5.76001 11.6046 5.80699C11.7318 5.84832 11.8688 5.84832 11.996 5.80699C12.1406 5.76001 12.2661 5.6346 12.5169 5.38379L14.0735 3.82711C14.2412 4.23509 14.3337 4.68191 14.3337 5.15033C14.3337 7.07412 12.7741 8.63366 10.8503 8.63366C10.6184 8.63366 10.3918 8.61099 10.1725 8.56775C9.86462 8.50703 9.71067 8.47667 9.61734 8.48597C9.51813 8.49585 9.46923 8.51073 9.38132 8.55778C9.29862 8.60203 9.21568 8.68498 9.04978 8.85087L4.51699 13.3837C3.99232 13.9083 3.14166 13.9083 2.61699 13.3837C2.09232 12.859 2.09232 12.0083 2.61699 11.4836L7.14978 6.95087C7.31568 6.78498 7.39862 6.70203 7.44288 6.61933C7.48992 6.53142 7.5048 6.48252 7.51468 6.38331C7.52398 6.28998 7.49362 6.13603 7.4329 5.82814C7.38966 5.6089 7.36699 5.38226 7.36699 5.15033C7.36699 3.22653 8.92653 1.66699 10.8503 1.66699C11.4871 1.66699 12.084 1.83788 12.5977 2.1363ZM8.00036 9.90029L11.4837 13.3836C12.0083 13.9083 12.859 13.9083 13.3837 13.3836C13.9083 12.8589 13.9083 12.0083 13.3836 11.4836L10.518 8.61801C10.3152 8.59882 10.1174 8.56222 9.92616 8.50974C9.67975 8.4421 9.40946 8.49119 9.22878 8.67187L8.00036 9.90029Z" stroke="#475467" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                              <p className="wrapper-hardware__text">24/7 Maintenance and Security</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Profitability Info */}
                <div className="wrapper-hardware__profitability_info">
                  <p className="wrapper-hardware__profitability_info-title">Profitability Info</p>
                  <div className="wrapper-hardware__profitability_info-block">
                    <div className="wrapper-hardware__profitability_info-group">
                      <p className="wrapper-hardware__profitability_info-group-title">Monthly Mining Output</p>
                      <p className="wrapper-hardware__profitability_info-group-value">{product.profitability.monthlyOutput}</p>
                    </div>
                    <span className="wrapper-hardware__profitability_info-border"></span>
                    <div className="wrapper-hardware__profitability_info-group">
                      <p className="wrapper-hardware__profitability_info-group-title">Breakeven</p>
                      <p className="wrapper-hardware__profitability_info-group-value">{product.profitability.breakeven}</p>
                    </div>
                    <span className="wrapper-hardware__profitability_info-border"></span>
                    <div className="wrapper-hardware__profitability_info-group">
                      <p className="wrapper-hardware__profitability_info-group-title">Return</p>
                      <p className="wrapper-hardware__profitability_info-group-value">{product.profitability.return}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Payment Details */}
        <div className="order-details">
          <div className="order-details__title-block">
            <h2 className="order-details__title">Payment Details</h2>
          </div>

          <div className="order-details__items">
            <div className="order-details__subtitle-block">
              <p className="order-details__subtitle"></p>
              <p className="order-details__subtitle">Price</p>
              <p className="order-details__subtitle">Quantity</p>
              <p className="order-details__subtitle">Total</p>
            </div>

            {/* Product Line Item */}
            <div className="order-details__item">
              <div className="order-details__item-name">{product.name}</div>
              <div className="order-details__item-price">
                <span className="order-details__price-background">${formatPrice(product.price)}</span>
              </div>
              <div className="order-details__item-quantity">{quantity}</div>
              <div className="order-details__item-total">${formatPrice(product.price * quantity)}</div>
            </div>

            {/* Installation Fee */}
            <div className="order-details__item">
              <div className="order-details__item-name">
                Installation Fee
                <div className="tooltip order-details__custom-tooltip">
                  <div className="tooltip-text">One-time payment that covers logistics, customs clearance and installation costs</div>
                  <svg className="default" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <g clipPath="url(#clip0_264_44934)">
                      <path d="M9.00018 12.2727V8.99999M9.00018 5.72727H9.00836M17.182 8.99999C17.182 13.5187 13.5189 17.1818 9.00018 17.1818C4.48148 17.1818 0.818359 13.5187 0.818359 8.99999C0.818359 4.4813 4.48148 0.818176 9.00018 0.818176C13.5189 0.818176 17.182 4.4813 17.182 8.99999Z" stroke="#667085" strokeLinecap="round" strokeLinejoin="round"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_264_44934">
                        <rect width="18" height="18" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className="order-details__item-price">
                <span className="order-details__price-background">${formatPrice(product.installationFee)}</span>
              </div>
              <div className="order-details__item-quantity">{quantity}</div>
              <div className="order-details__item-total">${formatPrice(product.installationFee * quantity)}</div>
            </div>

            {/* Monthly Hosting */}
            <div className="order-details__item">
              <div className="order-details__item-name">
                Monthly Hosting Fee
                <div className="tooltip order-details__custom-tooltip">
                  <div className="tooltip-text">Monthly charge covering electricity and maintenance</div>
                  <svg className="default" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <g clipPath="url(#clip0_264_44934)">
                      <path d="M9.00018 12.2727V8.99999M9.00018 5.72727H9.00836M17.182 8.99999C17.182 13.5187 13.5189 17.1818 9.00018 17.1818C4.48148 17.1818 0.818359 13.5187 0.818359 8.99999C0.818359 4.4813 4.48148 0.818176 9.00018 0.818176C13.5189 0.818176 17.182 4.4813 17.182 8.99999Z" stroke="#667085" strokeLinecap="round" strokeLinejoin="round"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_264_44934">
                        <rect width="18" height="18" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className="order-details__item-price">
                <span className="order-details__price-background">${formatPrice(product.monthlyHosting)}</span>
              </div>
              <div className="order-details__item-quantity">1</div>
              <div className="order-details__item-total">${formatPrice(product.monthlyHosting)}</div>
            </div>
          </div>

          {/* Summary Section */}
          <div className="order-details__summary">
            {/* Promocode */}
            <div className="order-details__discount-promo-block">
              <div className="order-details__discount-promo">
                <p className="order-details__summary-title">Promocode:</p>
                <div className="order-details__promocode-block">
                  <input 
                    placeholder="Promocode" 
                    className="order-details__promocode"
                    value={promocode}
                    onChange={(e) => setPromocode(e.target.value)}
                  />
                  <button className="transparent order-details__promocode-btn">
                    Confirm
                  </button>
                </div>
              </div>
            </div>

            {/* Discount */}
            <div className="order-details__discount">
              <div className="order-details__summary-title-block">
                <p className="order-details__summary-title">Discount</p>
                <p className="order-details__summary-subtitle">For bulk orders of 5+ or 10+ units, get up to 15% off.</p>
              </div>
              <div className="order-details__summary-value-block">
                <p className="order-details__summary-discount-value">${formatPrice(totals.discount)}</p>
                <span className="order-details__summary-discount-percent">{totals.discountPercent}%</span>
              </div>
            </div>

            {/* Total */}
            <div className="order-details__total">
              <p className="order-details__summary-title">Total Payment</p>
              <p className="order-details__summary-value">${formatPrice(totals.total)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer and Payment Options */}
      <div className="order-container__info-details">
        {/* Disclaimer */}
        <div className="disclaimer order-container__disclaimer">
          <p className="disclaimer__title">Disclaimer</p>
          <p className="disclaimer__description">
            These estimates offer forward-looking information based on current data, including mining difficulty: FPPS 0.00000041, and BTC reference rate of $175k. They are not guarantees of future results and should be viewed with caution due to market uncertainties.
          </p>
        </div>

        {/* Payment Options */}
        <div className="order-container__payment-options">
          <div className="container-payment">
            <div className="payment-container tariff_page_old">
              <div className="payment-container__form-payment">
                <div className="payment-container__payment-title">Payment Options:</div>
                
                <div className="payment-container__form-payment-block">
                  <div className="payment-container__form-payment-list-block">
                    <div className="payment-container__form-payment-list">
                      {/* Card Payment */}
                      <button 
                        className={`ui-payment-method-button ${selectedPayment === 'Card' ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedPayment('Card');
                          setShowOtherCrypto(false);
                        }}
                      >
                        <svg width="92" height="32" viewBox="0 0 92 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="ui-payment-method-button__icon">
                          <mask id="path-1-inside-1_0_4595" fill="white"><path d="M0 0H46V32H0V0Z"></path></mask>
                          <path d="M0 0H46V32H0V0Z" fill="white"></path>
                          <path d="M46 0H45V32H46H47V0H46Z" fill="#EAECF0" mask="url(#path-1-inside-1_0_4595)"></path>
                          <path fillRule="evenodd" clipRule="evenodd" d="M14.3341 21.1443H11.5877L9.52833 13.0565C9.43058 12.6844 9.22304 12.3555 8.91774 12.2005C8.15584 11.811 7.31628 11.5009 6.40039 11.3446V11.0332H10.8245C11.4351 11.0332 11.893 11.5009 11.9694 12.0442L13.0379 17.8782L15.7829 11.0332H18.4529L14.3341 21.1443ZM19.9794 21.1443H17.3857L19.5214 11.0332H22.1151L19.9794 21.1443ZM25.4707 13.8343C25.547 13.2897 26.0049 12.9783 26.5392 12.9783C27.3788 12.9001 28.2933 13.0565 29.0565 13.4447L29.5145 11.2677C28.7512 10.9564 27.9117 10.8 27.1498 10.8C24.6324 10.8 22.8007 12.2005 22.8007 14.1443C22.8007 15.623 24.0982 16.3995 25.0141 16.8672C26.0049 17.3336 26.3865 17.645 26.3102 18.1114C26.3102 18.811 25.547 19.1224 24.7851 19.1224C23.8692 19.1224 22.9533 18.8892 22.1151 18.4996L21.6571 20.6779C22.573 21.0661 23.5639 21.2225 24.4798 21.2225C27.3024 21.2993 29.0565 19.9001 29.0565 17.8C29.0565 15.1553 25.4707 15.0003 25.4707 13.8343V13.8343ZM38.134 21.1443L36.0746 11.0332H33.8625C33.4046 11.0332 32.9466 11.3446 32.794 11.811L28.9805 21.1443H31.6505L32.1834 19.667H35.464L35.7693 21.1443H38.134ZM34.2439 13.7561L35.0058 17.5668H32.8701L34.2439 13.7561Z" fill="#172B85"></path>
                          <rect width="46" height="32" transform="translate(46)" fill="white"></rect>
                        </svg>
                        <span className="ui-payment-method-button__text">Card</span>
                      </button>

                      {/* Bank Transfer */}
                      <button 
                        className={`ui-payment-method-button ${selectedPayment === 'Bank' ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedPayment('Bank');
                          setShowOtherCrypto(false);
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ui-payment-method-button__icon">
                          <g style={{mixBlendMode: 'multiply'}}>
                            <path d="M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z" stroke="#1570EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                          </g>
                        </svg>
                        <span className="ui-payment-method-button__text">Bank Transfer</span>
                      </button>

                      {/* BTC */}
                      <button 
                        className={`ui-payment-method-button ${selectedPayment === 'BTC' ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedPayment('BTC');
                          setShowOtherCrypto(false);
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ui-payment-method-button__icon">
                          <g clipPath="url(#clip0_272_22442)">
                            <path d="M24 12C24 14.3734 23.2962 16.6935 21.9776 18.6668C20.6591 20.6402 18.7849 22.1783 16.5922 23.0866C14.3995 23.9948 11.9867 24.2324 9.65892 23.7694C7.33115 23.3064 5.19295 22.1635 3.51472 20.4853C1.83649 18.8071 0.693605 16.6689 0.230582 14.3411C-0.232441 12.0133 0.00519936 9.60051 0.913451 7.4078C1.8217 5.21509 3.35977 3.34094 5.33316 2.02236C7.30655 0.703788 9.62663 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12Z" fill="#F7931A"></path>
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.713 6.60268L9.568 6.60229L9.56874 4.22359L10.9975 4.22813L10.9954 6.50894L12.16 6.50973L12.157 4.20545L13.6092 4.20484L13.6048 6.52353C13.6048 6.52353 15.9489 6.42059 16.9517 8.08089C17.9545 9.74119 16.5429 11.1325 16.0383 11.3061C16.0383 11.3061 18.262 11.8498 18.1565 14.1199C18.051 16.39 16.107 17.3119 13.8279 17.4087L13.8449 19.8075L12.3927 19.8081L12.3966 17.441L11.2432 17.436L11.2436 19.8189L9.80222 19.8178L9.80571 17.4451L6.87362 17.4402L7.15279 15.7255C7.15279 15.7255 7.9806 15.7296 8.29112 15.7209C8.60164 15.7123 8.70789 15.3585 8.70876 15.033C8.70964 14.7075 8.60013 9.34629 8.60613 8.90083C8.61213 8.45537 8.47804 8.14458 7.95283 8.14865C7.42762 8.15272 6.70619 8.13257 6.70619 8.13257L6.713 6.60268ZM11.1848 12.5434L11.2329 15.6736C11.2329 15.6736 15.2442 16.0139 15.2143 14.0308C15.1844 12.0477 11.1848 12.5434 11.1848 12.5434ZM11.1514 11.0615L11.1553 8.18052C11.1553 8.18052 14.4372 7.90197 14.4522 9.50056C14.4672 11.0992 12.4674 11.0206 11.1514 11.0615Z" fill="white"></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_272_22442">
                              <rect width="24" height="24" fill="white"></rect>
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="ui-payment-method-button__text">BTC</span>
                      </button>

                      {/* Other Crypto */}
                      <button 
                        className="ui-payment-method-button"
                        onClick={() => setShowOtherCrypto(!showOtherCrypto)}
                      >
                        <span className="ui-payment-method-button__text">
                          <span className="payment-container__arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                              <path d="M4.5 6L8.5 10L12.5 6" stroke="#1570EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                          </span>
                          Other Crypto
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Terms and Buy Button */}
              <div className="payment-container__button-block">
                <div className="payment-container__checked-privacy_policy">
                  <label className="ui-checkbox payment-container__form-confirm-checkbox" tabIndex="0">
                    <input 
                      type="checkbox" 
                      className="ui-checkbox__input"
                      checked={agreedToTerms}
                      onChange={(e) => setAgreedToTerms(e.target.checked)}
                    />
                    <span className="ui-checkbox__visual"></span>
                    <span className="ui-checkbox__wrap">
                      <span className="ui-checkbox__text">
                        <div className="checked_box">
                          <span className="payment-container__text">I agree to your</span>
                          <a className="payment-container__link" href="https://ecos.am/en/refund-policy/" target="_blank" rel="noopener noreferrer">Refund Policy</a>
                          <span className="payment-container__text">and</span>
                          <a className="payment-container__link" href="https://ecos.am/en/terms-of-use/" target="_blank" rel="noopener noreferrer">Terms of use</a>
                        </div>
                      </span>
                    </span>
                  </label>
                </div>
                <div className="payment-container____button-block">
                  <div style={{position: 'relative'}}>
                    <button 
                      className={`orange ${!agreedToTerms ? 'disabled' : ''}`}
                      disabled={!agreedToTerms}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyAsics;
